import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CardRecoveryInterceptor } from './core/card-recovery.interceptor';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';

import { AppRouting } from './app.routing';
import { AppComponent } from './app.component';
import { BlockUIComponent } from './core/blockui/blockui';
import { TanzeelMessagingModule } from './core/messaging/messaging.module';
import { UiKitModule } from './uikit/uikit.module';

@NgModule({
  providers: [provideHttpClient(withInterceptorsFromDi()), { provide: HTTP_INTERCEPTORS, useClass: CardRecoveryInterceptor, multi: true }],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppRouting,
    TanzeelMessagingModule,
    UiKitModule,
  ],
  declarations: [AppComponent, BlockUIComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
